import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
function AccordionItem({ title, Content, id, length, isContentComponent }) {
  const [IsOpen, setIsOpen] = useState(id === 0 ? true : false);
  return (
    <article className={'flex flex-col border-b-slate-300 ' + (id === length - 1 ? ' border-none ' : ' border-b ')}>
      <button
        onClick={() => setIsOpen((prev) => !prev)}
        type="button"
        className={
          'w-full flex flex-row p-4 md:p-4 justify-between transition-all text-green-900 ' +
          (IsOpen ? ' bg-slate-300 ' : ' bg-slate-100 ') +
          (id === 0 ? ' rounded-t-xl ' : ' rounded-none ') +
          (id === length - 1 && !IsOpen ? ' rounded-b-xl ' : ' rounded-none ')
        }
        data-accordion-target="#accordion-collapse-body-1"
      >
        <p className={'text-start ' + (IsOpen ? 'font-bold' : 'font-semibold')}>{title}</p>
        <svg
          className={'w-6 h-6 shrink-0 transition-all ' + (IsOpen ? 'rotate-180' : 'rotate-0')}
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          ></path>
        </svg>
      </button>

      <AnimatePresence initial={false}>
        {IsOpen && (
          <motion.section
            className="w-full"
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: {
                // opacity: 1,
                scaleY: 1,
                height: 'auto',
              },
              collapsed: {
                // opacity: 0,
                scaleY: 0,
                height: 0,
              },
            }}
            transition={{
              duration: 0.5,
              ease: [0.04, 0.62, 0.23, 0.98],
            }}
          >
            <motion.div
              variants={{
                collapsed: {
                  // scaleY: 0,
                },
                open: { scaleY: 1 },
              }}
              transition={{
                duration: 0.5,
              }}
            >
              <div className="p-5">{isContentComponent ? <Content /> : Content}</div>
            </motion.div>
          </motion.section>
        )}
      </AnimatePresence>
    </article>
  );
}

export default function Accordion({ AccordionItems, isContentComponent = false }) {
  return (
    <div className="flex flex-col bg-transparent mx-2 md:mx-10">
      {AccordionItems.map((item, i) => {
        return (
          <div key={i}>
            <AccordionItem
              id={i}
              title={item.title}
              Content={item.content}
              length={AccordionItems.length}
              isContentComponent={isContentComponent}
            />
          </div>
        );
      })}
    </div>
  );
}
